var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149.9 129.6",
    style: {
      enableBackground: "new 0 0 149.9 129.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1-0.4l0,86.4l74.9,43.1l74.9-43.1V-0.3L1-0.4z M144.5,82.9l-68.6,39.4L7.2,82.9V55.2h137.3V82.9z M144.5,50.2 H7.2V5.3l137.3,0V50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,109l0-48.6c0-0.1-0.1-0.3-0.3-0.3h-5c-0.1,0-0.3,0.1-0.3,0.3v45.6l-5.7,3.1l-5.8-3.1V60.5 c0-0.1-0.1-0.3-0.3-0.3h-5c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.2l0,48.6c0,0.1,0,0.2,0.1,0.2l11,6.3c0.1,0,0.2,0,0.3,0 l10.9-6.3C87,109.2,87.1,109.1,87.1,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,104.6c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.1-0.2v-5.3c0-0.1,0-0.2-0.1-0.2l-10.5-5.7V80.4l9.4,2.4 c0.1,0,0.2-0.1,0.2-0.3l0-5.2c0-0.1-0.1-0.2-0.2-0.2l-9.4-2.1V65h10.4c0.1,0,0.2-0.1,0.2-0.3v-4.3c0-0.1-0.1-0.3-0.2-0.3H41.3 c-0.1,0-0.2,0.1-0.2,0.3v35c0,0.1,0,0.2,0.1,0.2L56.6,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,94.9v-4.7c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0l-10.3,5.6v-14l9.6-2.5c0.1,0,0.2-0.1,0.2-0.2v-4.6 c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.1-0.2-0.1l-9.5,2.1V65h10.4c0.1,0,0.3-0.1,0.3-0.3v-4.3c0-0.1-0.1-0.3-0.3-0.3H96.1 c-0.1,0-0.3,0.1-0.3,0.3v43.3c0,0.1,0,0.2,0.1,0.2c0.1,0,0.2,0,0.3,0l15.4-8.9C111.7,95.1,111.7,95,111.7,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,88.2l4.3,2.5c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2l0-30c0-0.1-0.1-0.3-0.3-0.3h-4.3 c-0.1,0-0.3,0.1-0.3,0.3V71l-10.3-2.3v-8.3c0-0.1-0.1-0.3-0.3-0.3h-4.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.2l0,18.9 c0,0.1,0,0.2,0.1,0.2l4.2,2.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2v-8.7L28,75.7V88C28,88.1,28,88.1,28.1,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.8,90.2c0.1,0,0.2,0,0.3,0l4.4-2.5c0,0,0,0,0-0.1V75.6l2.6-0.7l7.6,6.8c0.1,0.1,0.2,0.1,0.3,0.1l3.9-2.2 c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2l-6.6-5.6l4.7-1.2c1.6-0.4,1.8-1.1,1.8-2.7l0-7.7c-0.2-1.1-1-1.8-2.2-1.8 c-0.1,0-0.1,0-0.2,0l-16.5,0c-0.1,0-0.3,0.2-0.3,0.3l0,29.5C119.7,90.1,119.7,90.2,119.8,90.2z M124.5,65l8.9,0 c0.4,0,0.7,0.3,0.7,0.7V68c0,0.5-0.1,0.8-0.8,1l-8.9,1.9V65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40,44.2 40,18.2 54.2,18.2 54.2,11.3 15.6,11.3 15.6,18.2 29.8,18.2 29.8,44.2 40,44.2 40,44.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.3,43.6c-7.8,1.4-17.7,1.9-25-0.9c-6.2-2.2-9.9-7.6-10.7-12.8c-0.8-6.4,2.1-12.1,8.3-15.8 c7.2-4.3,18.7-4.1,26.5-1.2l0,0v7.2c-5.9-2.3-14.9-4.2-20.6-0.6c-4.1,2.6-5.4,6.8-4.3,10.9c0.8,3.3,4.2,6.2,8,7.3 c2.7,0.7,5.9,0.9,8.9,0.6l0,0V33l-3.9,0v-6.4h12.9L134.3,43.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,37.8l-3.4,6.5H51.1l16.7-33h11.6l17.1,33H86.2l-3.6-6.5H64.9L64.9,37.8L64.9,37.8z M73.8,19.5 l-6.1,11.6h11.9L73.8,19.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.36c812cc7c3e9b6c53ae0eb97d695cab.svg";
export { ForwardRef as ReactComponent };